module.exports = __webpack_public_path__ + "static/media/23.d53d1f47.png";